// // pages/GrazeBoxes/GrazeBoxDetails/AddToCartButton.jsx
// import React, { useState } from "react";
// import { Button, CircularProgress } from "@mui/material";
// import SnackbarAlert from "../../../components/SnackbarAlert";
// import { useCart } from "../../../context/CartContext";
// import { buildLineId } from "../../../utils/lineId";

// const AddToCartButton = ({
//   product, // {_id, name, displayName, images, category, subcategory}
//   selectedSize, // { sizeId, name, servesUpTo, ... }
//   selectedDiet, // { type, name, ... }
//   giftPackaging, // boolean
//   totalPrice, // computed current unit (list) price
// }) => {
//   const { addToCart, setShowCartPreview } = useCart();
//   const [loading, setLoading] = useState(false);
//   const [snack, setSnack] = useState({
//     open: false,
//     msg: "",
//     severity: "success",
//   });

//   const handleClick = async () => {
//     if (!selectedSize || !selectedDiet) return;
//     setLoading(true);

//     // Stable identity snapshot
//     const type = product.subcategory || product.category || "grazeBox";
//     const optionsForId = {
//       sizeId: selectedSize.sizeId, // 👈 stable key
//       dietType: selectedDiet.type, // 👈 stable key
//       gift: !!giftPackaging,
//     };
//     const lineId = buildLineId({
//       productId: product._id,
//       type,
//       options: optionsForId,
//     });

//     // Canonical line
//     const list = Number(totalPrice || 0);
//     const uiCustomizations = [
//       { key: "size", label: "Size", value: selectedSize.name },
//       {
//         key: "dietaryRestrictions",
//         label: "Dietary Restrictions",
//         value: selectedDiet.name,
//       },
//       {
//         key: "giftPackaging",
//         label: "Gift Packaging",
//         value: giftPackaging ? "Yes" : "No",
//       },
//     ];

//     const newItem = {
//       lineId,
//       productId: product._id,
//       type,
//       category: product.category || "grazeBox",
//       subcategory: product.subcategory || null,

//       name: product.name,
//       displayName: product.displayName,
//       image: product.images?.[0] || product.images?.primary || null,

//       size: { _id: selectedSize.sizeId, name: selectedSize.name },
//       flavor: null,
//       color: null,

//       customizations: uiCustomizations,
//       customization: uiCustomizations, // legacy compat

//       listPrice: list,
//       unitPrice: list,
//       quantity: 1,
//       totalPrice: list,

//       itemsPerSet: 1,
//     };

//     const result = await addToCart(newItem);
//     setLoading(false);
//     setShowCartPreview(true);

//     if (result.ok && result.synced) {
//       setSnack({
//         open: true,
//         msg: "Graze Box added to cart",
//         severity: "success",
//       });
//     } else if (result.ok && !result.synced) {
//       setSnack({
//         open: true,
//         msg: "Added to cart (sync failed, will retry)",
//         severity: "warning",
//       });
//     } else {
//       setSnack({
//         open: true,
//         msg: "Failed to add item. Try again.",
//         severity: "warning",
//       });
//     }

//     // Analytics
//     if (window.fbq) {
//       window.fbq("track", "AddToCart", {
//         content_name: product.displayName || product.name,
//         content_ids: [product._id],
//         content_type: "product",
//         value: list,
//         currency: "CAD",
//       });
//     }
//     if (window.gtag) {
//       window.gtag("event", "add_to_cart", {
//         currency: "CAD",
//         value: list,
//         items: [
//           {
//             item_id: product._id,
//             item_name: product.displayName || product.name,
//             price: list,
//             quantity: 1,
//             item_category: product.category || "grazeBox",
//             item_variant: `${selectedSize.name} | ${selectedDiet.name}${
//               giftPackaging ? " | Gift" : ""
//             }`,
//           },
//         ],
//       });
//     }
//   };

//   return (
//     <>
//       <Button
//         fullWidth
//         variant="contained"
//         color="primary"
//         onClick={handleClick}
//         disabled={loading || !selectedSize || !selectedDiet}
//         sx={{ textTransform: "none", fontWeight: "bold", mt: 2 }}>
//         {loading ? (
//           <CircularProgress size={24} color="inherit" />
//         ) : (
//           "Add to Cart"
//         )}
//       </Button>

//       <SnackbarAlert
//         open={snack.open}
//         onClose={() => setSnack((s) => ({ ...s, open: false }))}
//         message={snack.msg}
//         severity={snack.severity}
//         bgColor={snack.severity === "success" ? "#4caf50" : "#ffa000"}
//         iconColor="#fff"
//       />
//     </>
//   );
// };

// export default AddToCartButton;

// pages/GrazeBoxes/GrazeBoxDetails/AddToCartButton.jsx
import React, { useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import SnackbarAlert from "../../../components/SnackbarAlert";
import { useCart } from "../../../context/CartContext";
import { buildLineId } from "../../../utils/lineId";

const AddToCartButton = ({
  product, // {_id, name, displayName, images, category, subcategory}
  selectedSize, // { sizeId, name, servesUpTo, ... }  <-- not a MongoId
  selectedDiet, // { type, name, ... }
  giftPackaging, // boolean
  totalPrice, // computed current unit (list) price
}) => {
  const { addToCart, setShowCartPreview } = useCart();
  const [loading, setLoading] = useState(false);
  const [snack, setSnack] = useState({
    open: false,
    msg: "",
    severity: "success",
  });

  const handleClick = async () => {
    if (!selectedSize || !selectedDiet) return;
    setLoading(true);

    // Stable identity snapshot for deduping
    const type = product.subcategory || product.category || "grazeBox";
    const lineId = buildLineId({
      productId: product._id,
      type,
      options: {
        sizeKey: selectedSize.sizeId, // keep stable keys for identity
        dietType: selectedDiet.type,
        gift: !!giftPackaging,
      },
    });

    const list = Number(totalPrice || 0);

    // Human-facing customizations (what shows in cart/order)
    const uiCustomizations = [
      { key: "size", label: "Size", value: selectedSize.name },
      {
        key: "dietaryRestrictions",
        label: "Dietary Restrictions",
        value: selectedDiet.name,
      },
      {
        key: "giftPackaging",
        label: "Gift Packaging",
        value: giftPackaging ? "Yes" : "No",
      },
    ];

    const newItem = {
      // identity
      lineId,
      productId: product._id,
      type,
      category: product.category || "grazeBox",
      subcategory: product.subcategory || null,

      // display/meta
      name: product.name,
      displayName: product.displayName,
      image: product.images?.[0] || product.images?.primary || null,

      // options (IMPORTANT: _id MUST NOT be a non-Mongo string)
      size: { _id: null, name: selectedSize.name }, // <-- make _id null
      flavor: null,
      color: null,

      // carry customizations under both keys
      customizations: uiCustomizations,
      customization: uiCustomizations,

      // pricing
      listPrice: list,
      unitPrice: list,
      quantity: 1,
      totalPrice: list,
      itemsPerSet: 1,
    };

    const result = await addToCart(newItem);
    setLoading(false);
    setShowCartPreview(true);

    setSnack({
      open: true,
      msg:
        result.ok && result.synced
          ? "Graze Box added to cart"
          : result.ok
          ? "Added to cart (sync failed, will retry)"
          : "Failed to add item. Try again.",
      severity: result.ok ? (result.synced ? "success" : "warning") : "warning",
    });

    // Analytics (unchanged)
    if (window.fbq) {
      window.fbq("track", "AddToCart", {
        content_name: product.displayName || product.name,
        content_ids: [product._id],
        content_type: "product",
        value: list,
        currency: "CAD",
      });
    }
    if (window.gtag) {
      window.gtag("event", "add_to_cart", {
        currency: "CAD",
        value: list,
        items: [
          {
            item_id: product._id,
            item_name: product.displayName || product.name,
            price: list,
            quantity: 1,
            item_category: product.category || "grazeBox",
            item_variant: `${selectedSize.name} | ${selectedDiet.name}${
              giftPackaging ? " | Gift" : ""
            }`,
          },
        ],
      });
    }
  };

  return (
    <>
      <Button
        fullWidth
        variant="contained"
        color="primary"
        onClick={handleClick}
        disabled={loading || !selectedSize || !selectedDiet}
        sx={{ textTransform: "none", fontWeight: "bold", mt: 2 }}>
        {loading ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          "Add to Cart"
        )}
      </Button>

      <SnackbarAlert
        open={snack.open}
        onClose={() => setSnack((s) => ({ ...s, open: false }))}
        message={snack.msg}
        severity={snack.severity}
        bgColor={snack.severity === "success" ? "#4caf50" : "#ffa000"}
        iconColor="#fff"
      />
    </>
  );
};

export default AddToCartButton;
